import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=7bebbbb4&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=ts&"
export * from "./Cover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bebbbb4",
  null
  
)

export default component.exports